import useChangeCallback from "@jnctn/hooks/useChangeCallback";
import { ComponentProps, ReactElement } from "react";
import cx from "classnames";

export function SelectOption({
  value,
  disabled,
  children,
  className,
}: {
  value: string;
  disabled?: boolean;
  children: string;
  className?: string;
}) {
  return (
    <option
      disabled={disabled}
      value={value}
      className={cx(className)}
    >
      {children}
    </option>
  );
}

export type SelectOptionElement = ReactElement<
  ComponentProps<typeof SelectOption>
>;

export default function Select({
  children,
  onChange,
  className,
  value,
  disabled,
  label,
}: {
  children: SelectOptionElement[] | SelectOptionElement;
  onChange: (value: string) => void;
  className?: string;
  value: string;
  disabled?: boolean;
  label?: string;
}) {
  const changeHandler = useChangeCallback<HTMLSelectElement>(onChange);
  return (
    <select
      aria-label={label}
      disabled={disabled}
      onChange={changeHandler}
      className={className}
      value={value}
    >
      {children}
    </select>
  );
}
